import BaseSearchService from "./BaseSearchService";

export default class OrdersSearchService extends BaseSearchService {
    public searchOrders(accountUserId: number | null, languageId: string,
        searchTerm: string, pageSize: number | null = null, pageIndex: number | null,
        pathAndQueryString: string): Promise<any> {

        return this.axios
            .post(`/api/orders/search?languageId=${languageId}`, {
                languageId: languageId,
                accountUserId: accountUserId,
                searchTerm: searchTerm,
                pageSize: pageSize,
                pageIndex: pageIndex,
                pathAndQueryString: pathAndQueryString
            },
                { withCredentials: !this.isDev })
            .then((res) => {
                return res.data;
            });
    }

    public searchOrdersProducts(accountId: number | null, languageId: string,
        pageSize: number | null = null, pageIndex: number | null,
        pathAndQueryString: string): Promise<any> {

        return this.axios
            .post(`/api/orders/search-products?languageId=${languageId}`, {
                languageId: languageId,
                accountId: accountId,
                pageSize: pageSize,
                pageIndex: pageIndex,
                pathAndQueryString: pathAndQueryString
            },
                { withCredentials: !this.isDev })
            .then((res) => {
                return res.data;
            });
    }

    public pushSearchHistory(pathAndQueryString: string, languageId: string) {
        return this.axios
            .post(`/api/orders/last-search-endpoint?languageId=${languageId}`, {
                pathAndQueryString: pathAndQueryString
            },
                { withCredentials: !this.isDev })
            .then((res) => {
                return res.data;
            });
    }
}